import React from 'react';
import { string, array, bool, oneOfType, number } from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import useStyles from 'hooks/useStyles';
import { SUBSCRIPTION } from 'constants/checkoutCollectionGroupTypes';
import { BUNDLE } from 'constants/checkoutCollectionTypes';

import { getPlanCardBundleDescription } from 'utils/bundle';

import CountdownDate from 'components/CountdownDate';
import Price from '../Price';
import PaymentOptionButton from '../PaymentOptionButton';

import checkoutCollectionStyles from 'styles/checkoutCollection.scss';
import paymentOptionStyles from '../PaymentOption/PaymentOption.scss';
import styles from './PaymentBundleOptionEnhanced.scss';

export default function PaymentBundleOption({
  contentType,
  contentId,
  optionList,
  groupType,
  shouldShowDetail,
}) {
  useStyles(styles, paymentOptionStyles, checkoutCollectionStyles);

  const { t } = useTranslation(['purchase']);

  const [firstOption] = optionList;

  const {
    id,
    hasPresale,
    presaleExpiredAt,
    plan: { name, description, highlight, billingCyclePerMonths },
    displayPrice: { originalPrice, sellingPrice, discount },
  } = firstOption;

  const optionCountList = getPlanCardBundleDescription(optionList, t);

  const showPromotionSection = highlight || hasPresale;

  const renderPromotionLabel = () => {
    if (highlight)
      return (
        <div
          className={cx(
            checkoutCollectionStyles.labelAccent,
            styles.labelAccent,
          )}
        >
          {highlight}
        </div>
      );
    if (hasPresale)
      return (
        <div className={checkoutCollectionStyles.label}>
          {t('purchase.promoOfferTag.limited')}
        </div>
      );

    return null;
  };

  return (
    <div className={paymentOptionStyles.root}>
      {shouldShowDetail && (
        <div
          className={cx(paymentOptionStyles.planContent, styles.planContent)}
        >
          <h3 className={paymentOptionStyles.name}>{name}</h3>
          <div className={paymentOptionStyles.description}>{description}</div>
        </div>
      )}
      {optionList.length > 0 && (
        <div className={styles.information}>
          {showPromotionSection && (
            <div
              className={cx(
                checkoutCollectionStyles.promotion,
                styles.promotion,
              )}
            >
              {renderPromotionLabel()}
              {hasPresale && <CountdownDate dateTo={presaleExpiredAt} />}
            </div>
          )}
          <h3 className={styles.name}>{name}</h3>
          <div
            className={checkoutCollectionStyles.bundleOptions}
            dangerouslySetInnerHTML={{
              __html: optionCountList,
            }}
          />
          <Price
            perMonth={billingCyclePerMonths}
            sellingPrice={sellingPrice}
            originalPrice={originalPrice}
            hasDiscount={!!discount}
            hasUnit={groupType === SUBSCRIPTION}
            className={styles.price}
            hasMultiplePrices={optionList.length > 1}
          />
          <PaymentOptionButton
            type={BUNDLE}
            checkoutId={id}
            discount={discount}
            isHighlighted={!!highlight}
            contentType={contentType}
            contentId={contentId}
            buttonProps={{ reversed: true }}
          />
        </div>
      )}
    </div>
  );
}

PaymentBundleOption.propTypes = {
  optionList: array.isRequired,
  groupType: string.isRequired,
  contentType: string.isRequired,
  shouldShowDetail: bool,
  contentId: oneOfType([string, number]).isRequired,
};

PaymentBundleOption.defaultProps = {
  shouldShowDetail: false,
};
